import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export function InsightsMessagingQueueSkeleton() {
  return (
    <Box
      data-testid="featured-vendors-skeleton"
      sx={{ backgroundColor: '#FFF' }}
    >
      <Stack spacing={1}>
        <Skeleton sx={{ fontSize: '1rem' }} variant="text" />

        <Skeleton height={60} variant="rectangular" width={'100%'} />
        <Skeleton height={60} variant="rectangular" width={'100%'} />
      </Stack>
    </Box>
  );
}
